import { PlpBreadcrumb } from './PlpBreadcrumb';
import type { PlpBreadcrumbItem } from '../../utils/plpBreadcrumb';
import { PLP_DESKTOP_BANNER_CLASS } from '../../constants';
import type { ReactNode } from 'react';
import { getCdnBaseUrl } from '@/core/utils/apiUtils';

export function PlpHeader({
  title,
  imageUrl,
  totalCount,
  countLabel = 'Designs',
  breadcrumbItems,
  renderDesktopBanner,
  showDesktopBanner = true,
  insetFromParent = false,
}: {
  title: string;
  imageUrl?: string;
  totalCount?: number;
  countLabel?: string;
  breadcrumbItems?: PlpBreadcrumbItem[];
  renderDesktopBanner?: ReactNode;
  /** When false, desktop shows title/count only (no 1510×110 banner). Mobile hero is unchanged. */
  showDesktopBanner?: boolean;
  /** When true, parent shell provides desktop horizontal padding — skip duplicate inset. */
  insetFromParent?: boolean;
}) {
  const displayTitle = (title || 'Jewellery').trim().toUpperCase();
  const showBreadcrumb = Boolean(breadcrumbItems?.length);
  const resolvedImageUrl = imageUrl ?? `${getCdnBaseUrl()}assets/plp-header-bg.webp`;
  const desktopInsetClass = insetFromParent ? 'md:px-0' : '';

  return (
    <>
      {/* Mobile: hero with optional background image */}
      <section
        className="relative flex min-h-[120px] flex-shrink-0 flex-col px-4 pb-4 pt-4 md:hidden justify-end"
        style={{
          backgroundImage: `url(${resolvedImageUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'bottom right',
        }}
      >
        <div className="relative w-full">
          <h1 className="text-lg font-bold tracking-tight text-primary-color">
            {displayTitle}
          </h1>
        </div>
      </section>

      {/* Desktop: breadcrumb → 1510×110 banner → title | count */}
      <section className={`hidden flex-shrink-0 flex-col pt-4 md:flex px-4 ${desktopInsetClass}`}>
        {showBreadcrumb && breadcrumbItems ? (
          <div className={`px-4 pb-3 ${desktopInsetClass}`}>
            <PlpBreadcrumb items={breadcrumbItems} />
          </div>
        ) : null}

        {showDesktopBanner ? (
          <div className={`${PLP_DESKTOP_BANNER_CLASS} overflow-hidden rounded-sm bg-[#E8E4DF] p-[2px] shadow-[0_0_5px_1px_rgba(0,0,0,0.1)]`}>
            {renderDesktopBanner ?? (
              <img
                src={resolvedImageUrl}
                alt=""
                className="h-full w-full object-cover object-[bottom_right]"
                decoding="async"
              />
            )}
          </div>
        ) : null}

        <div className={`flex flex-wrap items-baseline gap-x-3 gap-y-1 px-4 pb-4 ${desktopInsetClass} ${showDesktopBanner ? 'pt-4' : 'pt-0'}`}>          <h1 className="font-serif text-3xl font-normal tracking-tight text-[#F15D47]">
            {displayTitle}
          </h1>
          {totalCount != null ? (
            <>
              <span className="text-gray-300" aria-hidden>
                |
              </span>
              <span className="text-base text-gray-500">
                {totalCount} {countLabel}
              </span>
            </>
          ) : null}
        </div>
      </section>
    </>
  );
}
